import React, { createRef } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { func, node, string } from 'prop-types';

class ButtonDisabler extends React.Component {
  constructor(...params) {
    super(...params);
    this.ref = React.createRef();
  }

  handleClick = async () => {
    if(resolve(this, 'ref/current', false)) this.ref.current.setAttribute('disabled', 'disabled');
    await this.props.handleClick();
    if(resolve(this, 'ref/current', false)) this.ref.current.removeAttribute('disabled');
  };

  render () {
    const {
      ButtonComponent,
      buttonText,
    } = this.props;

    return (
      <ButtonComponent ref={this.ref} onClick={this.handleClick} {...this.props}>
        {buttonText}
      </ButtonComponent>
    );
  }
}

ButtonDisabler.propTypes = {
  handleClick: func,
  ButtonComponent: node,
  buttonText: string
};

export default ButtonDisabler;